import type { LocalizedField } from '../../types/metadata.ts'

export interface ICountry {
    code: string;
    label: LocalizedField;
    native: string;
    emoji: string;
    emojiU: string;
}

export const COUNTRIES: ICountry[] = [
    {
        code: "am",
        label: {
            en: "Armenia",
            ru: "Армения",
            hy: "Հայաստան",
        },
        native: "Հայաստան",
        emoji: "🇦🇲",
        emojiU: "U+1F1E6 U+1F1F2",
    },
    {
        code: "us",
        label: {
            en: "United States",
            ru: "Соединенные Штаты",
            hy: "Միացյալ Նահանգներ",
        },
        native: "United States",
        emoji: "🇺🇸",
        emojiU: "U+1F1FA U+1F1F8",
    },
    {
        code: "ru",
        label: {
            en: "Russia",
            ru: "Россия",
            hy: "Ռուսաստան",
        },
        native: "Россия",
        emoji: "🇷🇺",
        emojiU: "U+1F1F7 U+1F1FA",
    },
    {
        code: "af",
        label: {
            en: "Afghanistan",
            ru: "Афганистан",
            hy: "Աֆղանստան",
        },
        native: "افغانستان",
        emoji: "🇦🇫",
        emojiU: "U+1F1E6 U+1F1EB",
    },
    {
        code: "ax",
        label: {
            en: "Aland Islands",
            ru: "Аландские острова",
            hy: "Ալանդյան կղզիներ",
        },
        native: "Åland",
        emoji: "🇦🇽",
        emojiU: "U+1F1E6 U+1F1FD",
    },
    {
        code: "al",
        label: {
            en: "Albania",
            ru: "Албания",
            hy: "Ալբանիա",
        },
        native: "Shqipëria",
        emoji: "🇦🇱",
        emojiU: "U+1F1E6 U+1F1F1",
    },
    {
        code: "dz",
        label: {
            en: "Algeria",
            ru: "Алжир",
            hy: "Ալժիր",
        },
        native: "الجزائر",
        emoji: "🇩🇿",
        emojiU: "U+1F1E9 U+1F1FF",
    },
    {
        code: "as",
        label: {
            en: "American Samoa",
            ru: "Американское Самоа",
            hy: "Ամերիկյան Սամոա",
        },
        native: "American Samoa",
        emoji: "🇦🇸",
        emojiU: "U+1F1E6 U+1F1F8",
    },
    {
        code: "ad",
        label: {
            en: "Andorra",
            ru: "Андорра",
            hy: "Անդորրա",
        },
        native: "Andorra",
        emoji: "🇦🇩",
        emojiU: "U+1F1E6 U+1F1E9",
    },
    {
        code: "ao",
        label: {
            en: "Angola",
            ru: "Ангола",
            hy: "Անգոլա",
        },
        native: "Angola",
        emoji: "🇦🇴",
        emojiU: "U+1F1E6 U+1F1F4",
    },
    {
        code: "ai",
        label: {
            en: "Anguilla",
            ru: "Ангилья",
            hy: "Անգուիլա",
        },
        native: "Anguilla",
        emoji: "🇦🇮",
        emojiU: "U+1F1E6 U+1F1EE",
    },
    {
        code: "aq",
        label: {
            en: "Antarctica",
            ru: "Антарктида",
            hy: "Անտարկտիդա",
        },
        native: "Antarctica",
        emoji: "🇦🇶",
        emojiU: "U+1F1E6 U+1F1F6",
    },
    {
        code: "ag",
        label: {
            en: "Antigua and Barbuda",
            ru: "Антигуа и Барбуда",
            hy: "Անտիգուա և Բարբուդա",
        },
        native: "Antigua and Barbuda",
        emoji: "🇦🇬",
        emojiU: "U+1F1E6 U+1F1EC",
    },
    {
        code: "ar",
        label: {
            en: "Argentina",
            ru: "Аргентина",
            hy: "Արգենտինա",
        },
        native: "Argentina",
        emoji: "🇦🇷",
        emojiU: "U+1F1E6 U+1F1F7",
    },

    {
        code: "aw",
        label: {
            en: "Aruba",
            ru: "Аруба",
            hy: "Արուբա",
        },
        native: "Aruba",
        emoji: "🇦🇼",
        emojiU: "U+1F1E6 U+1F1FC",
    },
    {
        code: "au",
        label: {
            en: "Australia",
            ru: "Австралия",
            hy: "Ավստրալիա",
        },
        native: "Australia",
        emoji: "🇦🇺",
        emojiU: "U+1F1E6 U+1F1FA",
    },
    {
        code: "at",
        label: {
            en: "Austria",
            ru: "Австрия",
            hy: "Ավստրիա",
        },
        native: "Österreich",
        emoji: "🇦🇹",
        emojiU: "U+1F1E6 U+1F1F9",
    },

    {
        code: "bh",
        label: {
            en: "Bahrain",
            ru: "Бахрейн",
            hy: "Բահրեյն",
        },
        native: "‏البحرين",
        emoji: "🇧🇭",
        emojiU: "U+1F1E7 U+1F1ED",
    },
    {
        code: "bd",
        label: {
            en: "Bangladesh",
            ru: "Бангладеш",
            hy: "Բանգլադեշ",
        },
        native: "Bangladesh",
        emoji: "🇧🇩",
        emojiU: "U+1F1E7 U+1F1E9",
    },
    {
        code: "bb",
        label: {
            en: "Barbados",
            ru: "Барбадос",
            hy: "Բարբադոս",
        },
        native: "Barbados",
        emoji: "🇧🇧",
        emojiU: "U+1F1E7 U+1F1E7",
    },
    {
        code: "by",
        label: {
            en: "Belarus",
            ru: "Беларусь",
            hy: "Բելառուս",
        },
        native: "Белару́сь",
        emoji: "🇧🇾",
        emojiU: "U+1F1E7 U+1F1FE",
    },
    {
        code: "be",
        label: {
            en: "Belgium",
            ru: "Бельгия",
            hy: "Բելգիա",
        },
        native: "België",
        emoji: "🇧🇪",
        emojiU: "U+1F1E7 U+1F1EA",
    },
    {
        code: "bz",
        label: {
            en: "Belize",
            ru: "Белиз",
            hy: "Բելիզ",
        },
        native: "Belize",
        emoji: "🇧🇿",
        emojiU: "U+1F1E7 U+1F1FF",
    },
    {
        code: "bj",
        label: {
            en: "Benin",
            ru: "Бенин",
            hy: "Բենին",
        },
        native: "Bénin",
        emoji: "🇧🇯",
        emojiU: "U+1F1E7 U+1F1EF",
    },
    {
        code: "bm",
        label: {
            en: "Bermuda",
            ru: "Бермуды",
            hy: "Բերմուդներ",
        },
        native: "Bermuda",
        emoji: "🇧🇲",
        emojiU: "U+1F1E7 U+1F1F2",
    },
    {
        code: "bt",
        label: {
            en: "Bhutan",
            ru: "Бутан",
            hy: "Բութան",
        },
        native: "ʼbrug-yul",
        emoji: "🇧🇹",
        emojiU: "U+1F1E7 U+1F1F9",
    },
    {
        code: "bo",
        label: {
            en: "Bolivia",
            ru: "Боливия",
            hy: "Բոլիվիա",
        },
        native: "Bolivia",
        emoji: "🇧🇴",
        emojiU: "U+1F1E7 U+1F1F4",
    },
    {
        code: "bq",
        label: {
            en: "Bonaire, Sint Eustatius and Saba",
            ru: "Бонайре, Синт-Эстатиус и Саба",
            hy: "Կարիբյան Նիդեռլանդներ",
        },
        native: "Caribisch Nederland",
        emoji: "🇧🇶",
        emojiU: "U+1F1E7 U+1F1F6",
    },
    {
        code: "ba",
        label: {
            en: "Bosnia and Herzegovina",
            ru: "Босния и Герцеговина",
            hy: "Բոսնիա և Հերցեգովինա",
        },
        native: "Bosna i Hercegovina",
        emoji: "🇧🇦",
        emojiU: "U+1F1E7 U+1F1E6",
    },
    {
        code: "bw",
        label: {
            en: "Botswana",
            ru: "Ботсвана",
            hy: "Բոտսվանա",
        },
        native: "Botswana",
        emoji: "🇧🇼",
        emojiU: "U+1F1E7 U+1F1FC",
    },
    {
        code: "bv",
        label: {
            en: "Bouvet Island",
            ru: "Остров Буве",
            hy: "Բուվե կղզի",
        },
        native: "Bouvetøya",
        emoji: "🇧🇻",
        emojiU: "U+1F1E7 U+1F1FB",
    },
    {
        code: "br",
        label: {
            en: "Brazil",
            ru: "Бразилия",
            hy: "Բրազիլիա",
        },
        native: "Brasil",
        emoji: "🇧🇷",
        emojiU: "U+1F1E7 U+1F1F7",
    },
    {
        code: "io",
        label: {
            en: "British Indian Ocean Territory",
            ru: "Британская территория в Индийском океане",
            hy: "Բրիտանական տարածք Հնդկական Օվկիանոսում",
        },
        native: "British Indian Ocean Territory",
        emoji: "🇮🇴",
        emojiU: "U+1F1EE U+1F1F4",
    },
    {
        code: "bn",
        label: {
            en: "Brunei",
            ru: "Бруней",
            hy: "Բրունեյ",
        },
        native: "Negara Brunei Darussalam",
        emoji: "🇧🇳",
        emojiU: "U+1F1E7 U+1F1F3",
    },
    {
        code: "bg",
        label: {
            en: "Bulgaria",
            ru: "Болгария",
            hy: "Բուլղարիա",
        },
        native: "България",
        emoji: "🇧🇬",
        emojiU: "U+1F1E7 U+1F1EC",
    },
    {
        code: "bf",
        label: {
            en: "Burkina Faso",
            ru: "Буркина-Фасо",
            hy: "Բուրկինա Ֆասո",
        },
        native: "Burkina Faso",
        emoji: "🇧🇫",
        emojiU: "U+1F1E7 U+1F1EB",
    },
    {
        code: "bi",
        label: {
            en: "Burundi",
            ru: "Бурунди",
            hy: "Բուրունդի",
        },
        native: "Burundi",
        emoji: "🇧🇮",
        emojiU: "U+1F1E7 U+1F1EE",
    },
    {
        code: "kh",
        label: {
            en: "Cambodia",
            ru: "Камбоджа",
            hy: "Կամբոջա",
        },
        native: "Kâmpŭchéa",
        emoji: "🇰🇭",
        emojiU: "U+1F1F0 U+1F1ED",
    },
    {
        code: "cm",
        label: {
            en: "Cameroon",
            ru: "Камерун",
            hy: "Կամերուն",
        },
        native: "Cameroon",
        emoji: "🇨🇲",
        emojiU: "U+1F1E8 U+1F1F2",
    },
    {
        code: "ca",
        label: {
            en: "Canada",
            ru: "Канада",
            hy: "Կանադա",
        },
        native: "Canada",
        emoji: "🇨🇦",
        emojiU: "U+1F1E8 U+1F1E6",
    },
    {
        code: "cv",
        label: {
            en: "Cape Verde",
            ru: "Кабо-Верде",
            hy: "Կաբո Վերդե",
        },
        native: "Cabo Verde",
        emoji: "🇨🇻",
        emojiU: "U+1F1E8 U+1F1FB",
    },
    {
        code: "ky",
        label: {
            en: "Cayman Islands",
            ru: "Каймановы острова",
            hy: "Կայմանյան կղզիներ",
        },
        native: "Cayman Islands",
        emoji: "🇰🇾",
        emojiU: "U+1F1F0 U+1F1FE",
    },
    {
        code: "cf",
        label: {
            en: "Central African Republic",
            ru: "Центральноафриканская Республика",
            hy: "Կենտրոնական Աֆրիկյան Հանրապետություն",
        },
        native: "Ködörösêse tî Bêafrîka",
        emoji: "🇨🇫",
        emojiU: "U+1F1E8 U+1F1EB",
    },
    {
        code: "td",
        label: {
            en: "Chad",
            ru: "Чад",
            hy: "Չադ",
        },
        native: "Tchad",
        emoji: "🇹🇩",
        emojiU: "U+1F1F9 U+1F1E9",
    },
    {
        code: "cl",
        label: {
            en: "Chile",
            ru: "Чили",
            hy: "Չիլի",
        },
        native: "Chile",
        emoji: "🇨🇱",
        emojiU: "U+1F1E8 U+1F1F1",
    },
    {
        code: "cn",
        label: {
            en: "China",
            ru: "Китай",
            hy: "Չինաստան",
        },
        native: "中国",
        emoji: "🇨🇳",
        emojiU: "U+1F1E8 U+1F1F3",
    },
    {
        code: "cx",
        label: {
            en: "Christmas Island",
            ru: "Остров Рождества",
            hy: "Սուրբ Ծննդյան կղզի",
        },
        native: "Christmas Island",
        emoji: "🇨🇽",
        emojiU: "U+1F1E8 U+1F1FD",
    },
    {
        code: "cc",
        label: {
            en: "Cocos (Keeling) Islands",
            ru: "Кокосовые (Килинг) острова",
            hy: "Կոկոսյան (Քիլինգ) կղզիներ",
        },
        native: "Cocos (Keeling) Islands",
        emoji: "🇨🇨",
        emojiU: "U+1F1E8 U+1F1E8",
    },
    {
        code: "co",
        label: {
            en: "Colombia",
            ru: "Колумбия",
            hy: "Կոլումբիա",
        },
        native: "Colombia",
        emoji: "🇨🇴",
        emojiU: "U+1F1E8 U+1F1F4",
    },
    {
        code: "km",
        label: {
            en: "Comoros",
            ru: "Коморские острова",
            hy: "Կոմորյան կղզիներ",
        },
        native: "Komori",
        emoji: "🇰🇲",
        emojiU: "U+1F1F0 U+1F1F2",
    },
    {
        code: "cg",
        label: {
            en: "Congo",
            ru: "Конго",
            hy: "Կոնգո - Բրազավիլ",
        },
        native: "République du Congo",
        emoji: "🇨🇬",
        emojiU: "U+1F1E8 U+1F1EC",
    },
    {
        code: "ck",
        label: {
            en: "Cook Islands",
            ru: "Острова Кука",
            hy: "Կուկի կղզիներ",
        },
        native: "Cook Islands",
        emoji: "🇨🇰",
        emojiU: "U+1F1E8 U+1F1F0",
    },
    {
        code: "cr",
        label: {
            en: "Costa Rica",
            ru: "Коста-Рика",
            hy: "Կոստա Ռիկա",
        },
        native: "Costa Rica",
        emoji: "🇨🇷",
        emojiU: "U+1F1E8 U+1F1F7",
    },
    {
        code: "hr",
        label: {
            en: "Croatia",
            ru: "Хорватия",
            hy: "Խորվաթիա",
        },
        native: "Hrvatska",
        emoji: "🇭🇷",
        emojiU: "U+1F1ED U+1F1F7",
    },
    {
        code: "cu",
        label: {
            en: "Cuba",
            ru: "Куба",
            hy: "Կուբա",
        },
        native: "Cuba",
        emoji: "🇨🇺",
        emojiU: "U+1F1E8 U+1F1FA",
    },
    {
        code: "cw",
        label: {
            en: "Curaçao",
            ru: "Кюрасао",
            hy: "Կյուրասաո",
        },
        native: "Curaçao",
        emoji: "🇨🇼",
        emojiU: "U+1F1E8 U+1F1FC",
    },
    {
        code: "cy",
        label: {
            en: "Cyprus",
            ru: "Кипр",
            hy: "Կիպրոս",
        },
        native: "Κύπρος",
        emoji: "🇨🇾",
        emojiU: "U+1F1E8 U+1F1FE",
    },
    {
        code: "cz",
        label: {
            en: "Czech Republic",
            ru: "Чешская Республика",
            hy: "Չեխիա",
        },
        native: "Česká republika",
        emoji: "🇨🇿",
        emojiU: "U+1F1E8 U+1F1FF",
    },
    {
        code: "cd",
        label: {
            en: "Democratic Republic of the Congo",
            ru: "Демократическая Республика Конго",
            hy: "Կոնգո - Կինշասա",
        },
        native: "République démocratique du Congo",
        emoji: "🇨🇩",
        emojiU: "U+1F1E8 U+1F1E9",
    },
    {
        code: "dk",
        label: {
            en: "Denmark",
            ru: "Дания",
            hy: "Դանիա",
        },
        native: "Danmark",
        emoji: "🇩🇰",
        emojiU: "U+1F1E9 U+1F1F0",
    },
    {
        code: "dj",
        label: {
            en: "Djibouti",
            ru: "Джибути",
            hy: "Ջիբութի",
        },
        native: "Djibouti",
        emoji: "🇩🇯",
        emojiU: "U+1F1E9 U+1F1EF",
    },
    {
        code: "dm",
        label: {
            en: "Dominica",
            ru: "Доминика",
            hy: "Դոմինիկա",
        },
        native: "Dominica",
        emoji: "🇩🇲",
        emojiU: "U+1F1E9 U+1F1F2",
    },
    {
        code: "do",
        label: {
            en: "Dominican Republic",
            ru: "Доминиканская Республика",
            hy: "Դոմինիկյան Հանրապետություն",
        },
        native: "República Dominicana",
        emoji: "🇩🇴",
        emojiU: "U+1F1E9 U+1F1F4",
    },
    {
        code: "ec",
        label: {
            en: "Ecuador",
            ru: "Эквадор",
            hy: "Էկվադոր",
        },
        native: "Ecuador",
        emoji: "🇪🇨",
        emojiU: "U+1F1EA U+1F1E8",
    },
    {
        code: "eg",
        label: {
            en: "Egypt",
            ru: "Египет",
            hy: "Եգիպտոս",
        },
        native: "مصر‎",
        emoji: "🇪🇬",
        emojiU: "U+1F1EA U+1F1EC",
    },
    {
        code: "sv",
        label: {
            en: "El Salvador",
            ru: "Сальвадор",
            hy: "Սալվադոր",
        },
        native: "El Salvador",
        emoji: "🇸🇻",
        emojiU: "U+1F1F8 U+1F1FB",
    },
    {
        code: "gq",
        label: {
            en: "Equatorial Guinea",
            ru: "Экваториальная Гвинея",
            hy: "Հասարակածային Գվինեա",
        },
        native: "Guinea Ecuatorial",
        emoji: "🇬🇶",
        emojiU: "U+1F1EC U+1F1F6",
    },
    {
        code: "er",
        label: {
            en: "Eritrea",
            ru: "Эритрея",
            hy: "Էրիթրեա",
        },
        native: "ኤርትራ",
        emoji: "🇪🇷",
        emojiU: "U+1F1EA U+1F1F7",
    },
    {
        code: "ee",
        label: {
            en: "Estonia",
            ru: "Эстония",
            hy: "Էստոնիա",
        },
        native: "Eesti",
        emoji: "🇪🇪",
        emojiU: "U+1F1EA U+1F1EA",
    },
    {
        code: "sz",
        label: {
            en: "Eswatini",
            ru: "Эсватини",
            hy: "Էսվատինի",
        },
        native: "Swaziland",
        emoji: "🇸🇿",
        emojiU: "U+1F1F8 U+1F1FF",
    },
    {
        code: "et",
        label: {
            en: "Ethiopia",
            ru: "Эфиопия",
            hy: "Եթովպիա",
        },
        native: "ኢትዮጵያ",
        emoji: "🇪🇹",
        emojiU: "U+1F1EA U+1F1F9",
    },
    {
        code: "fk",
        label: {
            en: "Falkland Islands",
            ru: "Фолклендские острова",
            hy: "Ֆոլքլենդյան կղզիներ",
        },
        native: "Falkland Islands",
        emoji: "🇫🇰",
        emojiU: "U+1F1EB U+1F1F0",
    },
    {
        code: "fo",
        label: {
            en: "Faroe Islands",
            ru: "Фарерские острова",
            hy: "Ֆարերյան կղզիներ",
        },
        native: "Føroyar",
        emoji: "🇫🇴",
        emojiU: "U+1F1EB U+1F1F4",
    },
    {
        code: "fj",
        label: {
            en: "Fiji Islands",
            ru: "Острова Фиджи",
            hy: "Ֆիջի",
        },
        native: "Fiji",
        emoji: "🇫🇯",
        emojiU: "U+1F1EB U+1F1EF",
    },
    {
        code: "fi",
        label: {
            en: "Finland",
            ru: "Финляндия",
            hy: "Ֆինլանդիա",
        },
        native: "Suomi",
        emoji: "🇫🇮",
        emojiU: "U+1F1EB U+1F1EE",
    },
    {
        code: "fr",
        label: {
            en: "France",
            ru: "Франция",
            hy: "Ֆրանսիա",
        },
        native: "France",
        emoji: "🇫🇷",
        emojiU: "U+1F1EB U+1F1F7",
    },
    {
        code: "gf",
        label: {
            en: "French Guiana",
            ru: "Французская Гвиана",
            hy: "Ֆրանսիական Գվիանա",
        },
        native: "Guyane française",
        emoji: "🇬🇫",
        emojiU: "U+1F1EC U+1F1EB",
    },
    {
        code: "pf",
        label: {
            en: "French Polynesia",
            ru: "Французская Полинезия",
            hy: "Ֆրանսիական Պոլինեզիա",
        },
        native: "Polynésie française",
        emoji: "🇵🇫",
        emojiU: "U+1F1F5 U+1F1EB",
    },
    {
        code: "tf",
        label: {
            en: "French Southern Territories",
            ru: "Французские южные территории",
            hy: "Ֆրանսիական Հարավային Տարածքներ",
        },
        native: "Territoire des Terres australes et antarctiques fr",
        emoji: "🇹🇫",
        emojiU: "U+1F1F9 U+1F1EB",
    },
    {
        code: "ga",
        label: {
            en: "Gabon",
            ru: "Габон",
            hy: "Գաբոն",
        },
        native: "Gabon",
        emoji: "🇬🇦",
        emojiU: "U+1F1EC U+1F1E6",
    },
    {
        code: "ge",
        label: {
            en: "Georgia",
            ru: "Джорджия",
            hy: "Վրաստան",
        },
        native: "საქართველო",
        emoji: "🇬🇪",
        emojiU: "U+1F1EC U+1F1EA",
    },
    {
        code: "de",
        label: {
            en: "Germany",
            ru: "Германия",
            hy: "Գերմանիա",
        },
        native: "Deutschland",
        emoji: "🇩🇪",
        emojiU: "U+1F1E9 U+1F1EA",
    },
    {
        code: "gh",
        label: {
            en: "Ghana",
            ru: "Гана",
            hy: "Գանա",
        },
        native: "Ghana",
        emoji: "🇬🇭",
        emojiU: "U+1F1EC U+1F1ED",
    },
    {
        code: "gi",
        label: {
            en: "Gibraltar",
            ru: "Гибралтар",
            hy: "Ջիբրալթար",
        },
        native: "Gibraltar",
        emoji: "🇬🇮",
        emojiU: "U+1F1EC U+1F1EE",
    },
    {
        code: "gr",
        label: {
            en: "Greece",
            ru: "Греция",
            hy: "Հունաստան",
        },
        native: "Ελλάδα",
        emoji: "🇬🇷",
        emojiU: "U+1F1EC U+1F1F7",
    },
    {
        code: "gl",
        label: {
            en: "Greenland",
            ru: "Гренландия",
            hy: "Գրենլանդիա",
        },
        native: "Kalaallit Nunaat",
        emoji: "🇬🇱",
        emojiU: "U+1F1EC U+1F1F1",
    },
    {
        code: "gd",
        label: {
            en: "Grenada",
            ru: "Гренада",
            hy: "Գրենադա",
        },
        native: "Grenada",
        emoji: "🇬🇩",
        emojiU: "U+1F1EC U+1F1E9",
    },
    {
        code: "gp",
        label: {
            en: "Guadeloupe",
            ru: "Гваделупа",
            hy: "Գվադելուպա",
        },
        native: "Guadeloupe",
        emoji: "🇬🇵",
        emojiU: "U+1F1EC U+1F1F5",
    },
    {
        code: "gu",
        label: {
            en: "Guam",
            ru: "Гуам",
            hy: "Գուամ",
        },
        native: "Guam",
        emoji: "🇬🇺",
        emojiU: "U+1F1EC U+1F1FA",
    },
    {
        code: "gt",
        label: {
            en: "Guatemala",
            ru: "Гватемала",
            hy: "Գվատեմալա",
        },
        native: "Guatemala",
        emoji: "🇬🇹",
        emojiU: "U+1F1EC U+1F1F9",
    },
    {
        code: "gg",
        label: {
            en: "Guernsey",
            ru: "Гернси и Олдерни",
            hy: "Գերնսի",
        },
        native: "Guernsey",
        emoji: "🇬🇬",
        emojiU: "U+1F1EC U+1F1EC",
    },
    {
        code: "gn",
        label: {
            en: "Guinea",
            ru: "Гвинея",
            hy: "Գվինեա",
        },
        native: "Guinée",
        emoji: "🇬🇳",
        emojiU: "U+1F1EC U+1F1F3",
    },
    {
        code: "gw",
        label: {
            en: "Guinea-Bissau",
            ru: "Гвинея-Бисау",
            hy: "Գվինեա-Բիսաու",
        },
        native: "Guiné-Bissau",
        emoji: "🇬🇼",
        emojiU: "U+1F1EC U+1F1FC",
    },
    {
        code: "gy",
        label: {
            en: "Guyana",
            ru: "Гайана",
            hy: "Գայանա",
        },
        native: "Guyana",
        emoji: "🇬🇾",
        emojiU: "U+1F1EC U+1F1FE",
    },
    {
        code: "ht",
        label: {
            en: "Haiti",
            ru: "Гаити",
            hy: "Հայիթի",
        },
        native: "Haïti",
        emoji: "🇭🇹",
        emojiU: "U+1F1ED U+1F1F9",
    },
    {
        code: "hm",
        label: {
            en: "Heard Island and McDonald Islands",
            ru: "Остров Херд и острова Макдональд",
            hy: "Հերդ կղզի և ՄակԴոնալդի կղզիներ",
        },
        native: "Heard Island and McDonald Islands",
        emoji: "🇭🇲",
        emojiU: "U+1F1ED U+1F1F2",
    },
    {
        code: "hn",
        label: {
            en: "Honduras",
            ru: "Гондурас",
            hy: "Հոնդուրաս",
        },
        native: "Honduras",
        emoji: "🇭🇳",
        emojiU: "U+1F1ED U+1F1F3",
    },
    {
        code: "hk",
        label: {
            en: "Hong Kong S.A.R.",
            ru: "Гонконг С.А.Р.",
            hy: "Հոնկոնգի ՀՎՇ",
        },
        native: "香港",
        emoji: "🇭🇰",
        emojiU: "U+1F1ED U+1F1F0",
    },
    {
        code: "hu",
        label: {
            en: "Hungary",
            ru: "Венгрия",
            hy: "Հունգարիա",
        },
        native: "Magyarország",
        emoji: "🇭🇺",
        emojiU: "U+1F1ED U+1F1FA",
    },
    {
        code: "is",
        label: {
            en: "Iceland",
            ru: "Исландия",
            hy: "Իսլանդիա",
        },
        native: "Ísland",
        emoji: "🇮🇸",
        emojiU: "U+1F1EE U+1F1F8",
    },
    {
        code: "in",
        label: {
            en: "India",
            ru: "Индия",
            hy: "Հնդկաստան",
        },
        native: "भारत",
        emoji: "🇮🇳",
        emojiU: "U+1F1EE U+1F1F3",
    },
    {
        code: "id",
        label: {
            en: "Indonesia",
            ru: "Индонезия",
            hy: "Ինդոնեզիա",
        },
        native: "Indonesia",
        emoji: "🇮🇩",
        emojiU: "U+1F1EE U+1F1E9",
    },
    {
        code: "ir",
        label: {
            en: "Iran",
            ru: "Иран",
            hy: "Իրան",
        },
        native: "ایران",
        emoji: "🇮🇷",
        emojiU: "U+1F1EE U+1F1F7",
    },
    {
        code: "iq",
        label: {
            en: "Iraq",
            ru: "Ирак",
            hy: "Իրաք",
        },
        native: "العراق",
        emoji: "🇮🇶",
        emojiU: "U+1F1EE U+1F1F6",
    },
    {
        code: "ie",
        label: {
            en: "Ireland",
            ru: "Ирландия",
            hy: "Իռլանդիա",
        },
        native: "Éire",
        emoji: "🇮🇪",
        emojiU: "U+1F1EE U+1F1EA",
    },
    {
        code: "il",
        label: {
            en: "Israel",
            ru: "Израиль",
            hy: "Իսրայել",
        },
        native: "יִשְׂרָאֵל",
        emoji: "🇮🇱",
        emojiU: "U+1F1EE U+1F1F1",
    },
    {
        code: "it",
        label: {
            en: "Italy",
            ru: "Италия",
            hy: "Իտալիա",
        },
        native: "Italia",
        emoji: "🇮🇹",
        emojiU: "U+1F1EE U+1F1F9",
    },
    {
        code: "ci",
        label: {
            en: "Ivory Coast",
            ru: "Кот-д'Ивуар (Берег Слоновой Кости)",
            hy: "Կոտ դ՚Իվուար",
        },
        native: "Cote D'Ivoire",
        emoji: "🇨🇮",
        emojiU: "U+1F1E8 U+1F1EE",
    },
    {
        code: "jm",
        label: {
            en: "Jamaica",
            ru: "Ямайка",
            hy: "Ճամայկա",
        },
        native: "Jamaica",
        emoji: "🇯🇲",
        emojiU: "U+1F1EF U+1F1F2",
    },
    {
        code: "jp",
        label: {
            en: "Japan",
            ru: "Япония",
            hy: "Ճապոնիա",
        },
        native: "日本",
        emoji: "🇯🇵",
        emojiU: "U+1F1EF U+1F1F5",
    },
    {
        code: "je",
        label: {
            en: "Jersey",
            ru: "Джерси",
            hy: "Ջերսի",
        },
        native: "Jersey",
        emoji: "🇯🇪",
        emojiU: "U+1F1EF U+1F1EA",
    },
    {
        code: "jo",
        label: {
            en: "Jordan",
            ru: "Джордан",
            hy: "Հորդանան",
        },
        native: "الأردن",
        emoji: "🇯🇴",
        emojiU: "U+1F1EF U+1F1F4",
    },
    {
        code: "kz",
        label: {
            en: "Kazakhstan",
            ru: "Казахстан",
            hy: "Ղազախստան",
        },
        native: "Қазақстан",
        emoji: "🇰🇿",
        emojiU: "U+1F1F0 U+1F1FF",
    },
    {
        code: "ke",
        label: {
            en: "Kenya",
            ru: "Кения",
            hy: "Քենիա",
        },
        native: "Kenya",
        emoji: "🇰🇪",
        emojiU: "U+1F1F0 U+1F1EA",
    },
    {
        code: "ki",
        label: {
            en: "Kiribati",
            ru: "Кирибати",
            hy: "Կիրիբատի",
        },
        native: "Kiribati",
        emoji: "🇰🇮",
        emojiU: "U+1F1F0 U+1F1EE",
    },
    {
        code: "xk",
        label: {
            en: "Kosovo",
            ru: "Косово",
            hy: "Կոսովո",
        },
        native: "Republika e Kosovës",
        emoji: "🇽🇰",
        emojiU: "U+1F1FD U+1F1F0",
    },
    {
        code: "kw",
        label: {
            en: "Kuwait",
            ru: "Кувейт",
            hy: "Քուվեյթ",
        },
        native: "الكويت",
        emoji: "🇰🇼",
        emojiU: "U+1F1F0 U+1F1FC",
    },
    {
        code: "kg",
        label: {
            en: "Kyrgyzstan",
            ru: "Кыргызстан",
            hy: "Ղրղզստան",
        },
        native: "Кыргызстан",
        emoji: "🇰🇬",
        emojiU: "U+1F1F0 U+1F1EC",
    },
    {
        code: "la",
        label: {
            en: "Laos",
            ru: "Лаос",
            hy: "Լաոս",
        },
        native: "ສປປລາວ",
        emoji: "🇱🇦",
        emojiU: "U+1F1F1 U+1F1E6",
    },
    {
        code: "lv",
        label: {
            en: "Latvia",
            ru: "Латвия",
            hy: "Լատվիա",
        },
        native: "Latvija",
        emoji: "🇱🇻",
        emojiU: "U+1F1F1 U+1F1FB",
    },
    {
        code: "lb",
        label: {
            en: "Lebanon",
            ru: "Ливан",
            hy: "Լիբանան",
        },
        native: "لبنان",
        emoji: "🇱🇧",
        emojiU: "U+1F1F1 U+1F1E7",
    },
    {
        code: "ls",
        label: {
            en: "Lesotho",
            ru: "Лесото",
            hy: "Լեսոտո",
        },
        native: "Lesotho",
        emoji: "🇱🇸",
        emojiU: "U+1F1F1 U+1F1F8",
    },
    {
        code: "lr",
        label: {
            en: "Liberia",
            ru: "Либерия",
            hy: "Լիբերիա",
        },
        native: "Liberia",
        emoji: "🇱🇷",
        emojiU: "U+1F1F1 U+1F1F7",
    },
    {
        code: "ly",
        label: {
            en: "Libya",
            ru: "Ливия",
            hy: "Լիբիա",
        },
        native: "‏ليبيا",
        emoji: "🇱🇾",
        emojiU: "U+1F1F1 U+1F1FE",
    },
    {
        code: "li",
        label: {
            en: "Liechtenstein",
            ru: "Лихтенштейн",
            hy: "Լիխտենշտեյն",
        },
        native: "Liechtenstein",
        emoji: "🇱🇮",
        emojiU: "U+1F1F1 U+1F1EE",
    },
    {
        code: "lt",
        label: {
            en: "Lithuania",
            ru: "Литва",
            hy: "Լիտվա",
        },
        native: "Lietuva",
        emoji: "🇱🇹",
        emojiU: "U+1F1F1 U+1F1F9",
    },
    {
        code: "lu",
        label: {
            en: "Luxembourg",
            ru: "Люксембург",
            hy: "Լյուքսեմբուրգ",
        },
        native: "Luxembourg",
        emoji: "🇱🇺",
        emojiU: "U+1F1F1 U+1F1FA",
    },
    {
        code: "mo",
        label: {
            en: "Macau S.A.R.",
            ru: "Макао С.А.Р.",
            hy: "Չինաստանի Մակաո ՀՎՇ",
        },
        native: "澳門",
        emoji: "🇲🇴",
        emojiU: "U+1F1F2 U+1F1F4",
    },
    {
        code: "mg",
        label: {
            en: "Madagascar",
            ru: "Мадагаскар",
            hy: "Մադագասկար",
        },
        native: "Madagasikara",
        emoji: "🇲🇬",
        emojiU: "U+1F1F2 U+1F1EC",
    },
    {
        code: "mw",
        label: {
            en: "Malawi",
            ru: "Малави",
            hy: "Մալավի",
        },
        native: "Malawi",
        emoji: "🇲🇼",
        emojiU: "U+1F1F2 U+1F1FC",
    },
    {
        code: "my",
        label: {
            en: "Malaysia",
            ru: "Малайзия",
            hy: "Մալայզիա",
        },
        native: "Malaysia",
        emoji: "🇲🇾",
        emojiU: "U+1F1F2 U+1F1FE",
    },
    {
        code: "mv",
        label: {
            en: "Maldives",
            ru: "Мальдивы",
            hy: "Մալդիվներ",
        },
        native: "Maldives",
        emoji: "🇲🇻",
        emojiU: "U+1F1F2 U+1F1FB",
    },
    {
        code: "ml",
        label: {
            en: "Mali",
            ru: "Мали",
            hy: "Մալի",
        },
        native: "Mali",
        emoji: "🇲🇱",
        emojiU: "U+1F1F2 U+1F1F1",
    },
    {
        code: "mt",
        label: {
            en: "Malta",
            ru: "Мальта",
            hy: "Մալթա",
        },
        native: "Malta",
        emoji: "🇲🇹",
        emojiU: "U+1F1F2 U+1F1F9",
    },
    {
        code: "im",
        label: {
            en: "Man (Isle of)",
            ru: "Мэн (остров)",
            hy: "Մեն կղզի",
        },
        native: "Isle of Man",
        emoji: "🇮🇲",
        emojiU: "U+1F1EE U+1F1F2",
    },
    {
        code: "mh",
        label: {
            en: "Marshall Islands",
            ru: "Маршалловы острова",
            hy: "Մարշալյան կղզիներ",
        },
        native: "M̧ajeļ",
        emoji: "🇲🇭",
        emojiU: "U+1F1F2 U+1F1ED",
    },
    {
        code: "mq",
        label: {
            en: "Martinique",
            ru: "Мартиника",
            hy: "Մարտինիկա",
        },
        native: "Martinique",
        emoji: "🇲🇶",
        emojiU: "U+1F1F2 U+1F1F6",
    },
    {
        code: "mr",
        label: {
            en: "Mauritania",
            ru: "Мавритания",
            hy: "Մավրիտանիա",
        },
        native: "موريتانيا",
        emoji: "🇲🇷",
        emojiU: "U+1F1F2 U+1F1F7",
    },
    {
        code: "mu",
        label: {
            en: "Mauritius",
            ru: "Маврикий",
            hy: "Մավրիկիոս",
        },
        native: "Maurice",
        emoji: "🇲🇺",
        emojiU: "U+1F1F2 U+1F1FA",
    },
    {
        code: "yt",
        label: {
            en: "Mayotte",
            ru: "Майотта",
            hy: "Մայոտ",
        },
        native: "Mayotte",
        emoji: "🇾🇹",
        emojiU: "U+1F1FE U+1F1F9",
    },
    {
        code: "mx",
        label: {
            en: "Mexico",
            ru: "Мексика",
            hy: "Մեքսիկա",
        },
        native: "México",
        emoji: "🇲🇽",
        emojiU: "U+1F1F2 U+1F1FD",
    },
    {
        code: "fm",
        label: {
            en: "Micronesia",
            ru: "Микронезия",
            hy: "Միկրոնեզիա",
        },
        native: "Micronesia",
        emoji: "🇫🇲",
        emojiU: "U+1F1EB U+1F1F2",
    },
    {
        code: "md",
        label: {
            en: "Moldova",
            ru: "Молдова",
            hy: "Մոլդովա",
        },
        native: "Moldova",
        emoji: "🇲🇩",
        emojiU: "U+1F1F2 U+1F1E9",
    },
    {
        code: "mc",
        label: {
            en: "Monaco",
            ru: "Монако",
            hy: "Մոնակո",
        },
        native: "Monaco",
        emoji: "🇲🇨",
        emojiU: "U+1F1F2 U+1F1E8",
    },
    {
        code: "mn",
        label: {
            en: "Mongolia",
            ru: "Монголия",
            hy: "Մոնղոլիա",
        },
        native: "Монгол улс",
        emoji: "🇲🇳",
        emojiU: "U+1F1F2 U+1F1F3",
    },
    {
        code: "me",
        label: {
            en: "Montenegro",
            ru: "Черногория",
            hy: "Չեռնոգորիա",
        },
        native: "Црна Гора",
        emoji: "🇲🇪",
        emojiU: "U+1F1F2 U+1F1EA",
    },
    {
        code: "ms",
        label: {
            en: "Montserrat",
            ru: "Монтсеррат",
            hy: "Մոնսեռատ",
        },
        native: "Montserrat",
        emoji: "🇲🇸",
        emojiU: "U+1F1F2 U+1F1F8",
    },
    {
        code: "ma",
        label: {
            en: "Morocco",
            ru: "Марокко",
            hy: "Մարոկկո",
        },
        native: "المغرب",
        emoji: "🇲🇦",
        emojiU: "U+1F1F2 U+1F1E6",
    },
    {
        code: "mz",
        label: {
            en: "Mozambique",
            ru: "Мозамбик",
            hy: "Մոզամբիկ",
        },
        native: "Moçambique",
        emoji: "🇲🇿",
        emojiU: "U+1F1F2 U+1F1FF",
    },
    {
        code: "mm",
        label: {
            en: "Myanmar",
            ru: "Мьянма",
            hy: "Մյանմա (Բիրմա)",
        },
        native: "မြန်မာ",
        emoji: "🇲🇲",
        emojiU: "U+1F1F2 U+1F1F2",
    },
    {
        code: "na",
        label: {
            en: "Namibia",
            ru: "Намибия",
            hy: "Նամիբիա",
        },
        native: "Namibia",
        emoji: "🇳🇦",
        emojiU: "U+1F1F3 U+1F1E6",
    },
    {
        code: "nr",
        label: {
            en: "Nauru",
            ru: "Науру",
            hy: "Նաուրու",
        },
        native: "Nauru",
        emoji: "🇳🇷",
        emojiU: "U+1F1F3 U+1F1F7",
    },
    {
        code: "np",
        label: {
            en: "Nepal",
            ru: "Непал",
            hy: "Նեպալ",
        },
        native: "नपल",
        emoji: "🇳🇵",
        emojiU: "U+1F1F3 U+1F1F5",
    },
    {
        code: "nl",
        label: {
            en: "Netherlands",
            ru: "Нидерланды",
            hy: "Նիդեռլանդներ",
        },
        native: "Nederland",
        emoji: "🇳🇱",
        emojiU: "U+1F1F3 U+1F1F1",
    },
    {
        code: "nc",
        label: {
            en: "New Caledonia",
            ru: "Новая Каледония",
            hy: "Նոր Կալեդոնիա",
        },
        native: "Nouvelle-Calédonie",
        emoji: "🇳🇨",
        emojiU: "U+1F1F3 U+1F1E8",
    },
    {
        code: "nz",
        label: {
            en: "New Zealand",
            ru: "Новая Зеландия",
            hy: "Նոր Զելանդիա",
        },
        native: "New Zealand",
        emoji: "🇳🇿",
        emojiU: "U+1F1F3 U+1F1FF",
    },
    {
        code: "ni",
        label: {
            en: "Nicaragua",
            ru: "Никарагуа",
            hy: "Նիկարագուա",
        },
        native: "Nicaragua",
        emoji: "🇳🇮",
        emojiU: "U+1F1F3 U+1F1EE",
    },
    {
        code: "ne",
        label: {
            en: "Niger",
            ru: "Нигер",
            hy: "Նիգեր",
        },
        native: "Niger",
        emoji: "🇳🇪",
        emojiU: "U+1F1F3 U+1F1EA",
    },
    {
        code: "ng",
        label: {
            en: "Nigeria",
            ru: "Нигерия",
            hy: "Նիգերիա",
        },
        native: "Nigeria",
        emoji: "🇳🇬",
        emojiU: "U+1F1F3 U+1F1EC",
    },
    {
        code: "nu",
        label: {
            en: "Niue",
            ru: "Ниуэ",
            hy: "Նիուե",
        },
        native: "Niuē",
        emoji: "🇳🇺",
        emojiU: "U+1F1F3 U+1F1FA",
    },
    {
        code: "nf",
        label: {
            en: "Norfolk Island",
            ru: "Остров Норфолк",
            hy: "Նորֆոլկ կղզի",
        },
        native: "Norfolk Island",
        emoji: "🇳🇫",
        emojiU: "U+1F1F3 U+1F1EB",
    },
    {
        code: "kp",
        label: {
            en: "North Korea",
            ru: "Северная Корея",
            hy: "Հյուսիսային Կորեա",
        },
        native: "북한",
        emoji: "🇰🇵",
        emojiU: "U+1F1F0 U+1F1F5",
    },
    {
        code: "mk",
        label: {
            en: "North Macedonia",
            ru: "Северная Македония",
            hy: "Հյուսիսային Մակեդոնիա",
        },
        native: "Северна Македонија",
        emoji: "🇲🇰",
        emojiU: "U+1F1F2 U+1F1F0",
    },
    {
        code: "mp",
        label: {
            en: "Northern Mariana Islands",
            ru: "Северные Марианские острова",
            hy: "Հյուսիսային Մարիանյան կղզիներ",
        },
        native: "Northern Mariana Islands",
        emoji: "🇲🇵",
        emojiU: "U+1F1F2 U+1F1F5",
    },
    {
        code: "no",
        label: {
            en: "Norway",
            ru: "Норвегия",
            hy: "Նորվեգիա",
        },
        native: "Norge",
        emoji: "🇳🇴",
        emojiU: "U+1F1F3 U+1F1F4",
    },
    {
        code: "om",
        label: {
            en: "Oman",
            ru: "Оман",
            hy: "Օման",
        },
        native: "عمان",
        emoji: "🇴🇲",
        emojiU: "U+1F1F4 U+1F1F2",
    },
    {
        code: "pk",
        label: {
            en: "Pakistan",
            ru: "Пакистан",
            hy: "Պակիստան",
        },
        native: "پاکستان",
        emoji: "🇵🇰",
        emojiU: "U+1F1F5 U+1F1F0",
    },
    {
        code: "pw",
        label: {
            en: "Palau",
            ru: "Палау",
            hy: "Պալաու",
        },
        native: "Palau",
        emoji: "🇵🇼",
        emojiU: "U+1F1F5 U+1F1FC",
    },
    {
        code: "ps",
        label: {
            en: "Palestinian Territory Occupied",
            ru: "Оккупированная палестинская территория",
            hy: "Պաղեստինյան տարածքներ",
        },
        native: "فلسطين",
        emoji: "🇵🇸",
        emojiU: "U+1F1F5 U+1F1F8",
    },
    {
        code: "pa",
        label: {
            en: "Panama",
            ru: "Панама",
            hy: "Պանամա",
        },
        native: "Panamá",
        emoji: "🇵🇦",
        emojiU: "U+1F1F5 U+1F1E6",
    },
    {
        code: "pg",
        label: {
            en: "Papua New Guinea",
            ru: "Папуа - Новая Гвинея",
            hy: "Պապուա Նոր Գվինեա",
        },
        native: "Papua Niugini",
        emoji: "🇵🇬",
        emojiU: "U+1F1F5 U+1F1EC",
    },
    {
        code: "py",
        label: {
            en: "Paraguay",
            ru: "Парагвай",
            hy: "Պարագվայ",
        },
        native: "Paraguay",
        emoji: "🇵🇾",
        emojiU: "U+1F1F5 U+1F1FE",
    },
    {
        code: "pe",
        label: {
            en: "Peru",
            ru: "Перу",
            hy: "Պերու",
        },
        native: "Perú",
        emoji: "🇵🇪",
        emojiU: "U+1F1F5 U+1F1EA",
    },
    {
        code: "ph",
        label: {
            en: "Philippines",
            ru: "Филиппины",
            hy: "Ֆիլիպիններ",
        },
        native: "Pilipinas",
        emoji: "🇵🇭",
        emojiU: "U+1F1F5 U+1F1ED",
    },
    {
        code: "pn",
        label: {
            en: "Pitcairn Island",
            ru: "Остров Питкэрн",
            hy: "Պիտկեռն կղզիներ",
        },
        native: "Pitcairn Islands",
        emoji: "🇵🇳",
        emojiU: "U+1F1F5 U+1F1F3",
    },
    {
        code: "pl",
        label: {
            en: "Poland",
            ru: "Польша",
            hy: "Լեհաստան",
        },
        native: "Polska",
        emoji: "🇵🇱",
        emojiU: "U+1F1F5 U+1F1F1",
    },
    {
        code: "pt",
        label: {
            en: "Portugal",
            ru: "Португалия",
            hy: "Պորտուգալիա",
        },
        native: "Portugal",
        emoji: "🇵🇹",
        emojiU: "U+1F1F5 U+1F1F9",
    },
    {
        code: "pr",
        label: {
            en: "Puerto Rico",
            ru: "Пуэрто-Рико",
            hy: "Պուերտո Ռիկո",
        },
        native: "Puerto Rico",
        emoji: "🇵🇷",
        emojiU: "U+1F1F5 U+1F1F7",
    },
    {
        code: "qa",
        label: {
            en: "Qatar",
            ru: "Катар",
            hy: "Կատար",
        },
        native: "قطر",
        emoji: "🇶🇦",
        emojiU: "U+1F1F6 U+1F1E6",
    },
    {
        code: "re",
        label: {
            en: "Reunion",
            ru: "Воссоединение",
            hy: "Ռեյունիոն",
        },
        native: "La Réunion",
        emoji: "🇷🇪",
        emojiU: "U+1F1F7 U+1F1EA",
    },
    {
        code: "ro",
        label: {
            en: "Romania",
            ru: "Румыния",
            hy: "Ռումինիա",
        },
        native: "România",
        emoji: "🇷🇴",
        emojiU: "U+1F1F7 U+1F1F4",
    },

    {
        code: "rw",
        label: {
            en: "Rwanda",
            ru: "Руанда",
            hy: "Ռուանդա",
        },
        native: "Rwanda",
        emoji: "🇷🇼",
        emojiU: "U+1F1F7 U+1F1FC",
    },
    {
        code: "sh",
        label: {
            en: "Saint Helena",
            ru: "Святая Елена",
            hy: "Սուրբ Հեղինեի կղզի",
        },
        native: "Saint Helena",
        emoji: "🇸🇭",
        emojiU: "U+1F1F8 U+1F1ED",
    },
    {
        code: "kn",
        label: {
            en: "Saint Kitts and Nevis",
            ru: "Сент-Китс и Невис",
            hy: "Սենթ Քիտս և Նևիս",
        },
        native: "Saint Kitts and Nevis",
        emoji: "🇰🇳",
        emojiU: "U+1F1F0 U+1F1F3",
    },
    {
        code: "lc",
        label: {
            en: "Saint Lucia",
            ru: "Сент-Люсия",
            hy: "Սենթ Լյուսիա",
        },
        native: "Saint Lucia",
        emoji: "🇱🇨",
        emojiU: "U+1F1F1 U+1F1E8",
    },
    {
        code: "pm",
        label: {
            en: "Saint Pierre and Miquelon",
            ru: "Сен-Пьер и Микелон",
            hy: "Սեն Պիեռ և Միքելոն",
        },
        native: "Saint-Pierre-et-Miquelon",
        emoji: "🇵🇲",
        emojiU: "U+1F1F5 U+1F1F2",
    },
    {
        code: "vc",
        label: {
            en: "Saint Vincent and the Grenadines",
            ru: "Сент-Винсент и Гренадины",
            hy: "Սենթ Վինսենթ և Գրենադիններ",
        },
        native: "Saint Vincent and the Grenadines",
        emoji: "🇻🇨",
        emojiU: "U+1F1FB U+1F1E8",
    },
    {
        code: "bl",
        label: {
            en: "Saint-Barthelemy",
            ru: "Сен-Бартелеми",
            hy: "Սուրբ Բարդուղիմեոս",
        },
        native: "Saint-Barthélemy",
        emoji: "🇧🇱",
        emojiU: "U+1F1E7 U+1F1F1",
    },
    {
        code: "mf",
        label: {
            en: "Saint-Martin (French part)",
            ru: "Сен-Мартен (французская часть)",
            hy: "Սեն Մարտեն",
        },
        native: "Saint-Martin",
        emoji: "🇲🇫",
        emojiU: "U+1F1F2 U+1F1EB",
    },
    {
        code: "ws",
        label: {
            en: "Samoa",
            ru: "Самоа",
            hy: "Սամոա",
        },
        native: "Samoa",
        emoji: "🇼🇸",
        emojiU: "U+1F1FC U+1F1F8",
    },
    {
        code: "sm",
        label: {
            en: "San Marino",
            ru: "Сан-Марино",
            hy: "Սան Մարինո",
        },
        native: "San Marino",
        emoji: "🇸🇲",
        emojiU: "U+1F1F8 U+1F1F2",
    },
    {
        code: "st",
        label: {
            en: "Sao Tome and Principe",
            ru: "Сан-Томе и Принсипи",
            hy: "Սան Տոմե և Փրինսիպի",
        },
        native: "São Tomé e Príncipe",
        emoji: "🇸🇹",
        emojiU: "U+1F1F8 U+1F1F9",
    },
    {
        code: "sa",
        label: {
            en: "Saudi Arabia",
            ru: "Саудовская Аравия",
            hy: "Սաուդյան Արաբիա",
        },
        native: "المملكة العربية السعودية",
        emoji: "🇸🇦",
        emojiU: "U+1F1F8 U+1F1E6",
    },
    {
        code: "sn",
        label: {
            en: "Senegal",
            ru: "Сенегал",
            hy: "Սենեգալ",
        },
        native: "Sénégal",
        emoji: "🇸🇳",
        emojiU: "U+1F1F8 U+1F1F3",
    },
    {
        code: "rs",
        label: {
            en: "Serbia",
            ru: "Сербия",
            hy: "Սերբիա",
        },
        native: "Србија",
        emoji: "🇷🇸",
        emojiU: "U+1F1F7 U+1F1F8",
    },
    {
        code: "sc",
        label: {
            en: "Seychelles",
            ru: "Сейшельские острова",
            hy: "Սեյշելներ",
        },
        native: "Seychelles",
        emoji: "🇸🇨",
        emojiU: "U+1F1F8 U+1F1E8",
    },
    {
        code: "sl",
        label: {
            en: "Sierra Leone",
            ru: "Сьерра-Леоне",
            hy: "Սիեռա Լեոնե",
        },
        native: "Sierra Leone",
        emoji: "🇸🇱",
        emojiU: "U+1F1F8 U+1F1F1",
    },
    {
        code: "sg",
        label: {
            en: "Singapore",
            ru: "Сингапур",
            hy: "Սինգապուր",
        },
        native: "Singapore",
        emoji: "🇸🇬",
        emojiU: "U+1F1F8 U+1F1EC",
    },
    {
        code: "sx",
        label: {
            en: "Sint Maarten (Dutch part)",
            ru: "Синт-Мартен (голландская часть)",
            hy: "Սինտ Մարտեն",
        },
        native: "Sint Maarten",
        emoji: "🇸🇽",
        emojiU: "U+1F1F8 U+1F1FD",
    },
    {
        code: "sk",
        label: {
            en: "Slovakia",
            ru: "Словакия",
            hy: "Սլովակիա",
        },
        native: "Slovensko",
        emoji: "🇸🇰",
        emojiU: "U+1F1F8 U+1F1F0",
    },
    {
        code: "si",
        label: {
            en: "Slovenia",
            ru: "Словения",
            hy: "Սլովենիա",
        },
        native: "Slovenija",
        emoji: "🇸🇮",
        emojiU: "U+1F1F8 U+1F1EE",
    },
    {
        code: "sb",
        label: {
            en: "Solomon Islands",
            ru: "Соломоновы острова",
            hy: "Սողոմոնյան կղզիներ",
        },
        native: "Solomon Islands",
        emoji: "🇸🇧",
        emojiU: "U+1F1F8 U+1F1E7",
    },
    {
        code: "so",
        label: {
            en: "Somalia",
            ru: "Сомали",
            hy: "Սոմալի",
        },
        native: "Soomaaliya",
        emoji: "🇸🇴",
        emojiU: "U+1F1F8 U+1F1F4",
    },
    {
        code: "za",
        label: {
            en: "South Africa",
            ru: "Южная Африка",
            hy: "Հարավաֆրիկյան Հանրապետություն",
        },
        native: "South Africa",
        emoji: "🇿🇦",
        emojiU: "U+1F1FF U+1F1E6",
    },
    {
        code: "gs",
        label: {
            en: "South Georgia",
            ru: "Южная Джорджия",
            hy: "Հարավային Ջորջիա և Հարավային Սենդվիչյան կղզիներ",
        },
        native: "South Georgia",
        emoji: "🇬🇸",
        emojiU: "U+1F1EC U+1F1F8",
    },
    {
        code: "kr",
        label: {
            en: "South Korea",
            ru: "Южная Корея",
            hy: "Հարավային Կորեա",
        },
        native: "대한민국",
        emoji: "🇰🇷",
        emojiU: "U+1F1F0 U+1F1F7",
    },
    {
        code: "ss",
        label: {
            en: "South Sudan",
            ru: "Южный Судан",
            hy: "Հարավային Սուդան",
        },
        native: "South Sudan",
        emoji: "🇸🇸",
        emojiU: "U+1F1F8 U+1F1F8",
    },
    {
        code: "es",
        label: {
            en: "Spain",
            ru: "Испания",
            hy: "Իսպանիա",
        },
        native: "España",
        emoji: "🇪🇸",
        emojiU: "U+1F1EA U+1F1F8",
    },
    {
        code: "lk",
        label: {
            en: "Sri Lanka",
            ru: "Шри-Ланка",
            hy: "Շրի Լանկա",
        },
        native: "śrī laṃkāva",
        emoji: "🇱🇰",
        emojiU: "U+1F1F1 U+1F1F0",
    },
    {
        code: "sd",
        label: {
            en: "Sudan",
            ru: "Судан",
            hy: "Սուդան",
        },
        native: "السودان",
        emoji: "🇸🇩",
        emojiU: "U+1F1F8 U+1F1E9",
    },
    {
        code: "sr",
        label: {
            en: "Suriname",
            ru: "Суринам",
            hy: "Սուրինամ",
        },
        native: "Suriname",
        emoji: "🇸🇷",
        emojiU: "U+1F1F8 U+1F1F7",
    },
    {
        code: "sj",
        label: {
            en: "Svalbard and Jan Mayen Islands",
            ru: "Шпицберген и острова Ян-Майен",
            hy: "Սվալբարդ և Յան Մայեն",
        },
        native: "Svalbard og Jan Mayen",
        emoji: "🇸🇯",
        emojiU: "U+1F1F8 U+1F1EF",
    },
    {
        code: "se",
        label: {
            en: "Sweden",
            ru: "Швеция",
            hy: "Շվեդիա",
        },
        native: "Sverige",
        emoji: "🇸🇪",
        emojiU: "U+1F1F8 U+1F1EA",
    },
    {
        code: "ch",
        label: {
            en: "Switzerland",
            ru: "Швейцария",
            hy: "Շվեյցարիա",
        },
        native: "Schweiz",
        emoji: "🇨🇭",
        emojiU: "U+1F1E8 U+1F1ED",
    },
    {
        code: "sy",
        label: {
            en: "Syria",
            ru: "Сирия",
            hy: "Սիրիա",
        },
        native: "سوريا",
        emoji: "🇸🇾",
        emojiU: "U+1F1F8 U+1F1FE",
    },
    {
        code: "tw",
        label: {
            en: "Taiwan",
            ru: "Тайвань",
            hy: "Թայվան",
        },
        native: "臺灣",
        emoji: "🇹🇼",
        emojiU: "U+1F1F9 U+1F1FC",
    },
    {
        code: "tj",
        label: {
            en: "Tajikistan",
            ru: "Таджикистан",
            hy: "Տաջիկստան",
        },
        native: "Тоҷикистон",
        emoji: "🇹🇯",
        emojiU: "U+1F1F9 U+1F1EF",
    },
    {
        code: "tz",
        label: {
            en: "Tanzania",
            ru: "Танзания",
            hy: "Տանզանիա",
        },
        native: "Tanzania",
        emoji: "🇹🇿",
        emojiU: "U+1F1F9 U+1F1FF",
    },
    {
        code: "th",
        label: {
            en: "Thailand",
            ru: "Таиланд",
            hy: "Թաիլանդ",
        },
        native: "ประเทศไทย",
        emoji: "🇹🇭",
        emojiU: "U+1F1F9 U+1F1ED",
    },
    {
        code: "bs",
        label: {
            en: "The Bahamas",
            ru: "Багамы",
            hy: "Բահամյան կղզիներ",
        },
        native: "Bahamas",
        emoji: "🇧🇸",
        emojiU: "U+1F1E7 U+1F1F8",
    },
    {
        code: "gm",
        label: {
            en: "The Gambia",
            ru: "Гамбия",
            hy: "Գամբիա",
        },
        native: "Gambia",
        emoji: "🇬🇲",
        emojiU: "U+1F1EC U+1F1F2",
    },
    {
        code: "tl",
        label: {
            en: "Timor-Leste",
            ru: "Тимор-Лешти",
            hy: "Թիմոր Լեշտի",
        },
        native: "Timor-Leste",
        emoji: "🇹🇱",
        emojiU: "U+1F1F9 U+1F1F1",
    },
    {
        code: "tg",
        label: {
            en: "Togo",
            ru: "Того",
            hy: "Տոգո",
        },
        native: "Togo",
        emoji: "🇹🇬",
        emojiU: "U+1F1F9 U+1F1EC",
    },
    {
        code: "tk",
        label: {
            en: "Tokelau",
            ru: "Токелау",
            hy: "Տոկելաու",
        },
        native: "Tokelau",
        emoji: "🇹🇰",
        emojiU: "U+1F1F9 U+1F1F0",
    },
    {
        code: "to",
        label: {
            en: "Tonga",
            ru: "Тонга",
            hy: "Տոնգա",
        },
        native: "Tonga",
        emoji: "🇹🇴",
        emojiU: "U+1F1F9 U+1F1F4",
    },
    {
        code: "tt",
        label: {
            en: "Trinidad and Tobago",
            ru: "Тринидад и Тобаго",
            hy: "Տրինիդադ և Տոբագո",
        },
        native: "Trinidad and Tobago",
        emoji: "🇹🇹",
        emojiU: "U+1F1F9 U+1F1F9",
    },
    {
        code: "tn",
        label: {
            en: "Tunisia",
            ru: "Тунис",
            hy: "Թունիս",
        },
        native: "تونس",
        emoji: "🇹🇳",
        emojiU: "U+1F1F9 U+1F1F3",
    },
    {
        code: "tm",
        label: {
            en: "Turkmenistan",
            ru: "Туркменистан",
            hy: "Թուրքմենստան",
        },
        native: "Türkmenistan",
        emoji: "🇹🇲",
        emojiU: "U+1F1F9 U+1F1F2",
    },
    {
        code: "tc",
        label: {
            en: "Turks and Caicos Islands",
            ru: "Острова Теркс и Кайкос",
            hy: "Թըրքս և Կայկոս կղզիներ",
        },
        native: "Turks and Caicos Islands",
        emoji: "🇹🇨",
        emojiU: "U+1F1F9 U+1F1E8",
    },
    {
        code: "tv",
        label: {
            en: "Tuvalu",
            ru: "Тувалу",
            hy: "Տուվալու",
        },
        native: "Tuvalu",
        emoji: "🇹🇻",
        emojiU: "U+1F1F9 U+1F1FB",
    },
    {
        code: "ug",
        label: {
            en: "Uganda",
            ru: "Уганда",
            hy: "Ուգանդա",
        },
        native: "Uganda",
        emoji: "🇺🇬",
        emojiU: "U+1F1FA U+1F1EC",
    },
    {
        code: "ua",
        label: {
            en: "Ukraine",
            ru: "Украина",
            hy: "Ուկրաինա",
        },
        native: "Україна",
        emoji: "🇺🇦",
        emojiU: "U+1F1FA U+1F1E6",
    },
    {
        code: "ae",
        label: {
            en: "United Arab Emirates",
            ru: "Объединенные Арабские Эмираты",
            hy: "Արաբական Միացյալ Էմիրություններ",
        },
        native: "دولة الإمارات العربية المتحدة",
        emoji: "🇦🇪",
        emojiU: "U+1F1E6 U+1F1EA",
    },
    {
        code: "gb",
        label: {
            en: "United Kingdom",
            ru: "Великобритания",
            hy: "Միացյալ Թագավորություն",
        },
        native: "United Kingdom",
        emoji: "🇬🇧",
        emojiU: "U+1F1EC U+1F1E7",
    },

    {
        code: "um",
        label: {
            en: "United States Minor Outlying Islands",
            ru: "Малые отдаленные острова Соединенных Штатов",
            hy: "Արտաքին կղզիներ (ԱՄՆ)",
        },
        native: "United States Minor Outlying Islands",
        emoji: "🇺🇲",
        emojiU: "U+1F1FA U+1F1F2",
    },
    {
        code: "uy",
        label: {
            en: "Uruguay",
            ru: "Уругвай",
            hy: "Ուրուգվայ",
        },
        native: "Uruguay",
        emoji: "🇺🇾",
        emojiU: "U+1F1FA U+1F1FE",
    },
    {
        code: "uz",
        label: {
            en: "Uzbekistan",
            ru: "Узбекистан",
            hy: "Ուզբեկստան",
        },
        native: "O‘zbekiston",
        emoji: "🇺🇿",
        emojiU: "U+1F1FA U+1F1FF",
    },
    {
        code: "vu",
        label: {
            en: "Vanuatu",
            ru: "Вануату",
            hy: "Վանուատու",
        },
        native: "Vanuatu",
        emoji: "🇻🇺",
        emojiU: "U+1F1FB U+1F1FA",
    },
    {
        code: "va",
        label: {
            en: "Vatican City State (Holy See)",
            ru: "Город-государство Ватикан (Святой Престол)",
            hy: "Վատիկան",
        },
        native: "Vaticano",
        emoji: "🇻🇦",
        emojiU: "U+1F1FB U+1F1E6",
    },
    {
        code: "ve",
        label: {
            en: "Venezuela",
            ru: "Венесуэла",
            hy: "Վենեսուելա",
        },
        native: "Venezuela",
        emoji: "🇻🇪",
        emojiU: "U+1F1FB U+1F1EA",
    },
    {
        code: "vn",
        label: {
            en: "Vietnam",
            ru: "Вьетнам",
            hy: "Վիետնամ",
        },
        native: "Việt Nam",
        emoji: "🇻🇳",
        emojiU: "U+1F1FB U+1F1F3",
    },
    {
        code: "vg",
        label: {
            en: "Virgin Islands (British)",
            ru: "Виргинские острова (Британские)",
            hy: "Բրիտանական Վիրջինյան կղզիներ",
        },
        native: "British Virgin Islands",
        emoji: "🇻🇬",
        emojiU: "U+1F1FB U+1F1EC",
    },
    {
        code: "vi",
        label: {
            en: "Virgin Islands (US)",
            ru: "Виргинские острова (США)",
            hy: "ԱՄՆ Վիրջինյան կղզիներ",
        },
        native: "United States Virgin Islands",
        emoji: "🇻🇮",
        emojiU: "U+1F1FB U+1F1EE",
    },
    {
        code: "wf",
        label: {
            en: "Wallis and Futuna Islands",
            ru: "Острова Уоллис и Футуна",
            hy: "Ուոլիս և Ֆուտունա",
        },
        native: "Wallis et Futuna",
        emoji: "🇼🇫",
        emojiU: "U+1F1FC U+1F1EB",
    },
    {
        code: "eh",
        label: {
            en: "Western Sahara",
            ru: "Западная Сахара",
            hy: "Արևմտյան Սահարա",
        },
        native: "الصحراء الغربية",
        emoji: "🇪🇭",
        emojiU: "U+1F1EA U+1F1ED",
    },
    {
        code: "ye",
        label: {
            en: "Yemen",
            ru: "Йемен",
            hy: "Եմեն",
        },
        native: "اليَمَن",
        emoji: "🇾🇪",
        emojiU: "U+1F1FE U+1F1EA",
    },
    {
        code: "zm",
        label: {
            en: "Zambia",
            ru: "Замбия",
            hy: "Զամբիա",
        },
        native: "Zambia",
        emoji: "🇿🇲",
        emojiU: "U+1F1FF U+1F1F2",
    },
    {
        code: "zw",
        label: {
            en: "Zimbabwe",
            ru: "Зимбабве",
            hy: "Զիմբաբվե",
        },
        native: "Zimbabwe",
        emoji: "🇿🇼",
        emojiU: "U+1F1FF U+1F1FC",
    },
];
